'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwDropdownMultiItem = require('./CwDropdownMultiItem');

var _CwDropdownMultiItem2 = _interopRequireDefault(_CwDropdownMultiItem);

var _CwDropdownMulti = require('./CwDropdownMulti.scss');

var _CwDropdownMulti2 = _interopRequireDefault(_CwDropdownMulti);

var _domScrollIntoView = require('dom-scroll-into-view');

var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */

var CwDropdownMulti = function (_React$Component) {
  (0, _inherits3.default)(CwDropdownMulti, _React$Component);

  function CwDropdownMulti(props) {
    (0, _classCallCheck3.default)(this, CwDropdownMulti);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwDropdownMulti.__proto__ || (0, _getPrototypeOf2.default)(CwDropdownMulti)).call(this, props));

    _this.handleItemMouseEnter = function (index, enterPosition) {
      // Don't fire onMouseEnter if mouse didn't actually move (i.e. the dropdown was scrolled by arrow keys)
      if (_this.props.onMouseEnter && (_this._mousePosition.x !== enterPosition.x || _this._mousePosition.y !== enterPosition.y)) {
        _this.props.onMouseEnter(index);
      }
    };

    _this.handleItemMouseMove = function (position) {
      _this._mousePosition = position;
    };

    _this.handleItemClick = function (item) {
      if (_this.props.onClick) {
        _this.props.onClick(item);
      }
    };

    _this.handleItemMouseDown = function (blur) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(blur);
      }
    };

    _this.isMousedOver = function () {
      return _this._mousedOver;
    };

    _this.handleDropdownEnter = function () {
      _this._mousedOver = true;
    };

    _this.handleDropdownLeave = function () {
      _this._mousedOver = false;
    };

    _this._mousePosition = { x: 0, y: 0 };
    _this._mousedOver = false;
    return _this;
  }

  (0, _createClass3.default)(CwDropdownMulti, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollItemIntoView();
    }
  }, {
    key: 'scrollItemIntoView',
    value: function scrollItemIntoView() {
      var highlightedItem = this.refs['item-' + this.props.highlightedIndex];
      if (highlightedItem) {
        var itemNode = highlightedItem.div;
        var menuNode = this.refs.menu;
        (0, _domScrollIntoView2.default)(itemNode, menuNode, { onlyScrollIfNeeded: true });
      }
    }
  }, {
    key: 'findValue',
    value: function findValue(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i] === obj.id) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item, isHighlighted, index) {
      var isChecked = this.findValue(item, this.props.value);
      return _react2.default.createElement(_CwDropdownMultiItem2.default, {
        isHighlighted: isHighlighted,
        isChecked: isChecked,
        item: item,
        onClick: this.handleItemClick,
        onMouseEnter: this.handleItemMouseEnter,
        onMouseDown: this.handleItemMouseDown,
        onMouseMove: this.handleItemMouseMove,
        index: index,
        key: index,
        ref: 'item-' + index
      });
    }
  }, {
    key: 'renderToggle',
    value: function renderToggle(text, isHighlighted, index, isChecked) {
      return _react2.default.createElement(_CwDropdownMultiItem2.default, {
        isHighlighted: isHighlighted,
        isChecked: isChecked,
        item: { id: index, name: text },
        onClick: this.handleItemClick,
        onMouseEnter: this.handleItemMouseEnter,
        onMouseDown: this.handleItemMouseDown,
        onMouseMove: this.handleItemMouseMove,
        index: index,
        key: index,
        ref: 'item-' + index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.items.length === 0) {
        return _react2.default.createElement('div', { 'data-cwid': this.props.cwId, className: _CwDropdownMulti2.default.dropDown, style: this.props.style });
      } else {
        var selectAll = this.renderToggle(this.props.selectAllText, this.props.highlightedIndex === -1, -1, this.props.allSelected);

        var items = this.props.items.map(function (item, index) {
          return _this2.renderItem(item, _this2.props.highlightedIndex === index, index);
        });
        return _react2.default.createElement(
          'div',
          { 'data-cwid': this.props.cwId, className: _CwDropdownMulti2.default.dropDown, style: this.props.style, ref: 'menu', onMouseEnter: this.handleDropdownEnter, onMouseLeave: this.handleDropdownLeave },
          selectAll,
          items
        );
      }
    }
  }]);
  return CwDropdownMulti;
}(_react2.default.Component);

CwDropdownMulti.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Array of items to be listed in the dropdown.
   */
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    name: _propTypes2.default.string
  })),
  /**
   * Index of the currently highlighted item in the dropdown.
   */
  highlightedIndex: _propTypes2.default.number,
  /**
   * Set of style properties to determine the dropdown's size and position. Must contain left, top, and minWidth.
   */
  style: _propTypes2.default.shape({
    left: _propTypes2.default.number,
    top: _propTypes2.default.number,
    minWidth: _propTypes2.default.number
  }),
  /**
   * Callback function that is fired when dropdown is clicked.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function that is fired when dropdown is hovered over.
   */
  onMouseEnter: _propTypes2.default.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * Text to display on combobox picker
   */
  pickerText: _propTypes2.default.string,
  /**
   * Flag to show it all records have been selected
   */
  allSelected: _propTypes2.default.bool,
  /**
   * Localized text for the Select All option
   */
  selectAllText: _propTypes2.default.string.isRequired
};

exports.default = CwDropdownMulti;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdropdown/CwDropdownMulti.js
// module id = 834
// module chunks = 10